module.exports = __webpack_public_path__ + "static/health-infrastructure-a73a69d8c7198e23666b20737af2b7e7.png";